import React, { useState, useEffect } from 'react';
import Space from './Pages/Space'
import './Container.css';

let Container=(props)=>{
  const [user, setUser] = useState(props?.user);

  useEffect(() => {
    setUser(props?.user)
  });

  return (
    <div className="App">
        <div>
            <div className='request-form'>
              {user ? <Space user={user} /> : ''}
            </div>
        </div>
    </div>
  );
}

export default Container;